import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineTime = _resolveComponent("LineTime")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "Observaciones",
    modelValue: _ctx.dialogObservation,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogObservation) = $event)),
    class: "bg-light",
    onClosed: _ctx.onClosed
  }, {
    default: _withCtx(() => [
      (_ctx.rowIdObs>0)
        ? (_openBlock(), _createBlock(_component_LineTime, {
            key: 0,
            id: _ctx.rowIdObs,
            target: "accreditation"
          }, null, 8, ["id"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "onClosed"]))
}